import {
  Button,
  HeadingText,
  ParagraphText,
  StackLayout,
  styled,
} from "@leagueplatform/genesis-core";
import { useNavigate } from "react-router-dom";
import { APP_ROOT, SIGN_IN } from "common/app-managed-routes";
import { getMemberRegisterUrl } from "common/emblem-register-url";
import { QueryParamModal } from "components/query-param-modal/query-param-modal.component";
import LOGO from "assets/emblem-health-logo.svg";
import CITY_IMAGE from "assets/city.png";

import MOBILE_CITY_IMAGE from "assets/mobile_city.svg";

// Hero uses a CSS background rather than `<img>` so `background-size: cover`
// handles cropping without the intrinsic height blowing past the viewport.
const PageRoot = styled("div", {
  width: "100%",
  minHeight: "100dvh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#FFFFFF",
  "@tablet": { flexDirection: "row", height: "100dvh", overflow: "hidden" },
  "@laptop": { flexDirection: "row", height: "100dvh", overflow: "hidden" },
  "@desktop": { flexDirection: "row", height: "100dvh", overflow: "hidden" },
});

const HeroSide = styled("div", {
  width: "100%",
  height: "45svh",
  backgroundImage: `url(${MOBILE_CITY_IMAGE})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  "@tablet": {
    width: "50%",
    height: "100%",
    backgroundImage: `url(${CITY_IMAGE})`,
  },
  "@laptop": {
    width: "50%",
    height: "100%",
    backgroundImage: `url(${CITY_IMAGE})`,
  },
  "@desktop": {
    width: "50%",
    height: "100%",
    backgroundImage: `url(${CITY_IMAGE})`,
  },
});

const ContentSide = styled("div", {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "$two $two $oneAndHalf",
  // Anchor for the bottom-pinned privacy link on mobile.
  position: "relative",
  flexGrow: 1,
  "@tablet": { width: "50%", height: "100%", flexGrow: 0 },
  "@laptop": { width: "50%", height: "100%", flexGrow: 0 },
  "@desktop": { width: "50%", height: "100%", flexGrow: 0 },
});

const ContentInner = styled("div", {
  width: "100%",
  maxWidth: "520px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const LogoImage = styled("img", {
  width: "320px",
  maxWidth: "100%",
  "@mobile": { width: "270px" },
  "@mobileLandscape": { width: "270px" },
});

export const PreLoginLandingPage = () => {
  const navigate = useNavigate();

  return (
    <PageRoot>
      <HeroSide aria-hidden="true" />

      <ContentSide>
        <ContentInner>
          <HeadingText
            size="xl"
            level="1"
            css={{
              marginBottom: "$twoAndHalf",
              "@mobile": { marginBottom: "$two" },
              "@mobileLandscape": { marginBottom: "$two" },
            }}
          >
            <LogoImage src={LOGO} alt="Emblem Health" />
          </HeadingText>

          <StackLayout
            orientation="vertical"
            css={{ width: "100%", maxWidth: "360px", gap: "$one" }}
          >
            <Button
              size="large"
              priority="primary"
              width="fillContainer"
              onClick={() =>
                navigate(SIGN_IN, {
                  state: { redirectPath: APP_ROOT },
                })
              }
              css={{
                height: "56px",
                borderRadius: "9999px",
                backgroundColor: "#5B3880",
                color: "#FFFFFF",
                fontSize: "20px",
                fontWeight: 600,
              }}
            >
              Sign in
            </Button>

            <Button
              size="large"
              priority="secondary"
              width="fillContainer"
              onClick={() => {
                window.open(
                  getMemberRegisterUrl(),
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
              css={{
                height: "56px",
                borderRadius: "9999px",
                borderColor: "#1F1F1F",
                color: "#1F1F1F",
                fontSize: "20px",
                fontWeight: 600,
                backgroundColor: "#FFFFFF",
              }}
            >
              Create an account
            </Button>
          </StackLayout>
        </ContentInner>

        <ParagraphText
          css={{
            marginTop: "$oneAndHalf",
            textAlign: "center",
            fontSize: "16px",
            lineHeight: "24px",
            color: "#66686B",
            textDecoration: "underline",
            textUnderlineOffset: "2px",
            "@mobile": {
              position: "absolute",
              left: "$two",
              right: "$two",
              bottom: "$oneAndHalf",
              marginTop: 0,
            },
            "@mobileLandscape": {
              position: "absolute",
              left: "$two",
              right: "$two",
              bottom: "$oneAndHalf",
              marginTop: 0,
            },
          }}
        >
          <a
            href="https://www.emblemhealth.com/legal/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Digital Services Privacy Policy and Terms of Use
          </a>
        </ParagraphText>
      </ContentSide>
      <QueryParamModal isPublic />
    </PageRoot>
  );
};
